import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  TrendingDown, 
  TrendingUp, 
  Receipt, 
  FileText, 
  User, 
  LogOut,
  Shield
} from 'lucide-react';
import { APP_NAME, LOGO_ICON } from '../../constants/appConstants';
import { useAuth } from '../../contexts/AuthContext';
import ConfirmationModal from '../../components/ConfirmationModal';

const SuperAdminSidebar = () => {
  const { logout } = useAuth();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleConfirmLogout = async () => {
    setShowLogoutModal(false);
    await logout();
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  const menuItems = [
    { name: 'Dashboard', icon: LayoutDashboard, path: '/superadmin/dashboard' },
    { name: 'Users', icon: Users, path: '/superadmin/users' },
    { name: 'Expenses', icon: TrendingDown, path: '/superadmin/expenses' },
    { name: 'Revenues', icon: TrendingUp, path: '/superadmin/revenues' },
    { name: 'Bills', icon: Receipt, path: '/superadmin/bills' },
    { name: 'Proformas', icon: FileText, path: '/superadmin/proformas' },
    { name: 'Settings', icon: User, path: '/superadmin/settings' },
  ];
  

  return (
    <div className="bg-gray-900 text-white w-64 h-screen flex flex-col fixed left-0 top-0">
      {/* Header */}
      <div className="p-6 border-b border-gray-700 flex-shrink-0">
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <img 
              src={LOGO_ICON} 
              alt={`${APP_NAME} Logo`} 
              className="w-10 h-10 rounded-lg"
            />
          </div>
          <div className="min-w-0 flex-1">
            <h1 className="text-lg font-bold truncate">{APP_NAME}</h1>
            <div className="flex items-center space-x-1">
              <Shield className="w-3 h-3 text-purple-400" />
              <p className="text-xs text-purple-400">Super Admin</p>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-6 overflow-y-auto">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.name}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                    isActive
                      ? 'bg-secondary-600 text-white'
                      : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                  }`
                }
              >
                <item.icon className="w-5 h-5 flex-shrink-0" />
                <span className="font-medium truncate">{item.name}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-gray-700 flex-shrink-0">
        <button
          onClick={handleLogoutClick}
          className="flex items-center space-x-3 px-4 py-3 w-full text-left text-gray-300 hover:bg-red-600 hover:text-white rounded-lg transition-colors"
        >
          <LogOut className="w-5 h-5 flex-shrink-0" />
          <span className="font-medium truncate">Logout</span>
        </button>
      </div>

      {/* Logout Confirmation Modal */}
      <ConfirmationModal
        isOpen={showLogoutModal}
        onClose={handleCancelLogout}
        onConfirm={handleConfirmLogout}
        title="Confirm Logout"
        message="Are you sure you want to logout? You will be redirected to the login page."
      />
    </div>
  );
};

export default SuperAdminSidebar;